@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.inputWrapper {
  @include ui-md-text;

  width: 100%;
  display: flex;
  min-width: 0;
  align-items: center;
  height: 36px;
  border: 2px solid var(--selected-stroke);
  caret-color: var(--selected-stroke);
  border-radius: 4px;
  background: var(--neutral-0);
  padding-left: 4px;
  column-gap: 4px;

  &.error {
    border-color: var(--red-50);

    &:focus-within {
      border-color: var(--red-50);
      box-shadow: none;
    }
  }

  input {
    font-family: inherit;
    width: 100%;
    padding-left: 1px;

    &::placeholder {
      @include md-regular;
      color: var(--light-40);
    }
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-shrink: 0;
    line-height: 20px;
    font-family: Inter;
    font-size: 16px;
    min-height: 32px;

    @include for-phone-only {
      font-size: 14px;
    }
  }

  [data-autopilot-system-redesign='on'] & {
    border: 1px solid var(--dark-80);
    caret-color: var(--dark-80);

    input {
      &::placeholder {
        @include sm-sohne;
        color: var(--dark-80);
      }
    }
  }
}
